import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MainLayoutComponent } from './component/main-layout/main-layout.component';
import { RouterModule } from '@angular/router';
import { NavigationModule } from '@core/navigation/navigation.module';
import { PreAuthLayoutComponent } from './component/pre-auth-layout/pre-auth-layout.component';
import { SharedModule } from '@shared/shared.module';
import { MidAuthLayoutComponent } from '@core/layout/component/mid-auth-layout/mid-auth-layout.component';
import { PureAuthLayoutComponent } from '@core/layout/component/pure-auth-layout/pure-auth-layout.component';

@NgModule({
  declarations: [
    MainLayoutComponent,
    PreAuthLayoutComponent,
    MidAuthLayoutComponent,
    PureAuthLayoutComponent
  ],
  imports: [
    RouterModule,
    CommonModule,
    SharedModule,
    NavigationModule,
    NavigationModule
  ],
  exports: [
    MainLayoutComponent,
    PreAuthLayoutComponent
  ]
})
export class LayoutModule {
}
